import { arbitrum, goerli, mainnet } from "wagmi/chains";

export const getChains = (network: string) =>
  network === "mainnet" ? [mainnet, arbitrum] : [goerli];
